/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateAddressBook = /* GraphQL */ `
  subscription OnCreateAddressBook(
    $filter: ModelSubscriptionAddressBookFilterInput
  ) {
    onCreateAddressBook(filter: $filter) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const onUpdateAddressBook = /* GraphQL */ `
  subscription OnUpdateAddressBook(
    $filter: ModelSubscriptionAddressBookFilterInput
  ) {
    onUpdateAddressBook(filter: $filter) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const onDeleteAddressBook = /* GraphQL */ `
  subscription OnDeleteAddressBook(
    $filter: ModelSubscriptionAddressBookFilterInput
  ) {
    onDeleteAddressBook(filter: $filter) {
      email
      userId
      expiry
      __typename
    }
  }
`;
export const onCreateCompletedDocument = /* GraphQL */ `
  subscription OnCreateCompletedDocument(
    $filter: ModelSubscriptionCompletedDocumentFilterInput
  ) {
    onCreateCompletedDocument(filter: $filter) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const onUpdateCompletedDocument = /* GraphQL */ `
  subscription OnUpdateCompletedDocument(
    $filter: ModelSubscriptionCompletedDocumentFilterInput
  ) {
    onUpdateCompletedDocument(filter: $filter) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const onDeleteCompletedDocument = /* GraphQL */ `
  subscription OnDeleteCompletedDocument(
    $filter: ModelSubscriptionCompletedDocumentFilterInput
  ) {
    onDeleteCompletedDocument(filter: $filter) {
      id
      name
      pdfKey
      draft
      locked
      lockedBy {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      lockedById
      annotations
      templateId
      template {
        id
        name
        pdfKey
        summary
        fillable
        daysUntilFinalized
        folderId
        createdBy
        createdAt
        updatedBy
        updatedAt
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      creator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      createdBy
      createdAt
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      foremanId
      updator {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      updatedBy
      updatedAt
      finalizeAfter
      authors
      __typename
    }
  }
`;
export const onCreateCrewMember = /* GraphQL */ `
  subscription OnCreateCrewMember(
    $filter: ModelSubscriptionCrewMemberFilterInput
  ) {
    onCreateCrewMember(filter: $filter) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const onUpdateCrewMember = /* GraphQL */ `
  subscription OnUpdateCrewMember(
    $filter: ModelSubscriptionCrewMemberFilterInput
  ) {
    onUpdateCrewMember(filter: $filter) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const onDeleteCrewMember = /* GraphQL */ `
  subscription OnDeleteCrewMember(
    $filter: ModelSubscriptionCrewMemberFilterInput
  ) {
    onDeleteCrewMember(filter: $filter) {
      id
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rateOverride {
        crewMemberId
        locationId
        rate
        __typename
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      email
      name
      rate
      crewMemberUserId
      __typename
    }
  }
`;
export const onCreateCustomer = /* GraphQL */ `
  subscription OnCreateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onCreateCustomer(filter: $filter) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateCustomer = /* GraphQL */ `
  subscription OnUpdateCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onUpdateCustomer(filter: $filter) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteCustomer = /* GraphQL */ `
  subscription OnDeleteCustomer($filter: ModelSubscriptionCustomerFilterInput) {
    onDeleteCustomer(filter: $filter) {
      id
      number
      name
      active
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      __typename
    }
  }
`;
export const onCreateDailyReport = /* GraphQL */ `
  subscription OnCreateDailyReport(
    $filter: ModelSubscriptionDailyReportFilterInput
  ) {
    onCreateDailyReport(filter: $filter) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const onUpdateDailyReport = /* GraphQL */ `
  subscription OnUpdateDailyReport(
    $filter: ModelSubscriptionDailyReportFilterInput
  ) {
    onUpdateDailyReport(filter: $filter) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const onDeleteDailyReport = /* GraphQL */ `
  subscription OnDeleteDailyReport(
    $filter: ModelSubscriptionDailyReportFilterInput
  ) {
    onDeleteDailyReport(filter: $filter) {
      id
      submissionDate
      summary
      isCompleted
      anyoneInjured
      qaqcCompleted
      siteSecured
      pdfKey
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      media {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      type
      inspectionType
      foremanName
      customerName
      address
      taskArea
      weather
      correctiveActions {
        action
        dueDate
        assignedTo
        signature
        __typename
      }
      inspectionQuestion
      foremanSignature
      safetySignature
      __typename
    }
  }
`;
export const onCreateDocument = /* GraphQL */ `
  subscription OnCreateDocument($filter: ModelSubscriptionDocumentFilterInput) {
    onCreateDocument(filter: $filter) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDocument = /* GraphQL */ `
  subscription OnUpdateDocument($filter: ModelSubscriptionDocumentFilterInput) {
    onUpdateDocument(filter: $filter) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDocument = /* GraphQL */ `
  subscription OnDeleteDocument($filter: ModelSubscriptionDocumentFilterInput) {
    onDeleteDocument(filter: $filter) {
      id
      name
      pdfKey
      summary
      fillable
      daysUntilFinalized
      folderId
      folder {
        id
        name
        parentId
        __typename
      }
      createdBy
      creator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updator {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      updatedBy
      updatedAt
      __typename
    }
  }
`;
export const onCreateFolder = /* GraphQL */ `
  subscription OnCreateFolder($filter: ModelSubscriptionFolderFilterInput) {
    onCreateFolder(filter: $filter) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateFolder = /* GraphQL */ `
  subscription OnUpdateFolder($filter: ModelSubscriptionFolderFilterInput) {
    onUpdateFolder(filter: $filter) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteFolder = /* GraphQL */ `
  subscription OnDeleteFolder($filter: ModelSubscriptionFolderFilterInput) {
    onDeleteFolder(filter: $filter) {
      id
      name
      parentId
      parent {
        id
        name
        parentId
        __typename
      }
      __typename
    }
  }
`;
export const onCreateGroup = /* GraphQL */ `
  subscription OnCreateGroup($filter: ModelSubscriptionGroupFilterInput) {
    onCreateGroup(filter: $filter) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateGroup = /* GraphQL */ `
  subscription OnUpdateGroup($filter: ModelSubscriptionGroupFilterInput) {
    onUpdateGroup(filter: $filter) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteGroup = /* GraphQL */ `
  subscription OnDeleteGroup($filter: ModelSubscriptionGroupFilterInput) {
    onDeleteGroup(filter: $filter) {
      id
      name
      division
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      createdAt
      crewMemberIds
      members {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      __typename
    }
  }
`;
export const onCreateLocation = /* GraphQL */ `
  subscription OnCreateLocation($filter: ModelSubscriptionLocationFilterInput) {
    onCreateLocation(filter: $filter) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription OnUpdateLocation($filter: ModelSubscriptionLocationFilterInput) {
    onUpdateLocation(filter: $filter) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription OnDeleteLocation($filter: ModelSubscriptionLocationFilterInput) {
    onDeleteLocation(filter: $filter) {
      id
      name
      phoneNumber
      address
      address1
      city
      province
      postalCode
      maxDailyHours
      maxWeeklyHours
      utcOffset
      payPeriodStart
      syncTasks
      dailyTimeReportReceivers {
        email
        __typename
      }
      mediaTargetFilesize
      mediaCompression
      termsOfUseURL
      privacyURL
      supportURL
      __typename
    }
  }
`;
export const onCreateLongProcess = /* GraphQL */ `
  subscription OnCreateLongProcess(
    $filter: ModelSubscriptionLongProcessFilterInput
  ) {
    onCreateLongProcess(filter: $filter) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const onUpdateLongProcess = /* GraphQL */ `
  subscription OnUpdateLongProcess(
    $filter: ModelSubscriptionLongProcessFilterInput
  ) {
    onUpdateLongProcess(filter: $filter) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const onDeleteLongProcess = /* GraphQL */ `
  subscription OnDeleteLongProcess(
    $filter: ModelSubscriptionLongProcessFilterInput
  ) {
    onDeleteLongProcess(filter: $filter) {
      id
      processName
      status
      params
      startedAt
      updatedAt
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      expiry
      __typename
    }
  }
`;
export const onCreateMedia = /* GraphQL */ `
  subscription OnCreateMedia($filter: ModelSubscriptionMediaFilterInput) {
    onCreateMedia(filter: $filter) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const onUpdateMedia = /* GraphQL */ `
  subscription OnUpdateMedia($filter: ModelSubscriptionMediaFilterInput) {
    onUpdateMedia(filter: $filter) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const onDeleteMedia = /* GraphQL */ `
  subscription OnDeleteMedia($filter: ModelSubscriptionMediaFilterInput) {
    onDeleteMedia(filter: $filter) {
      id
      filename
      mediaType
      description
      sortKey
      dailyReportId
      dailyReport {
        id
        submissionDate
        summary
        isCompleted
        anyoneInjured
        qaqcCompleted
        siteSecured
        pdfKey
        locationId
        foremanId
        customerId
        userId
        type
        inspectionType
        foremanName
        customerName
        address
        taskArea
        weather
        inspectionQuestion
        foremanSignature
        safetySignature
        __typename
      }
      userId
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      createdAt
      customerId
      locationId
      __typename
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onCreateNotification(filter: $filter) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onUpdateNotification(filter: $filter) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const onDeleteNotification = /* GraphQL */ `
  subscription OnDeleteNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onDeleteNotification(filter: $filter) {
      id
      hasViewed
      status
      subject
      body
      content
      date
      expiry
      userId
      __typename
    }
  }
`;
export const onCreateQBSync = /* GraphQL */ `
  subscription OnCreateQBSync($filter: ModelSubscriptionQBSyncFilterInput) {
    onCreateQBSync(filter: $filter) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const onUpdateQBSync = /* GraphQL */ `
  subscription OnUpdateQBSync($filter: ModelSubscriptionQBSyncFilterInput) {
    onUpdateQBSync(filter: $filter) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const onDeleteQBSync = /* GraphQL */ `
  subscription OnDeleteQBSync($filter: ModelSubscriptionQBSyncFilterInput) {
    onDeleteQBSync(filter: $filter) {
      id
      sessionId
      session {
        id
        locationId
        expiry
        createdAt
        __typename
      }
      task
      status
      data
      createdAt
      expiry
      __typename
    }
  }
`;
export const onCreateRateOverride = /* GraphQL */ `
  subscription OnCreateRateOverride(
    $filter: ModelSubscriptionRateOverrideFilterInput
  ) {
    onCreateRateOverride(filter: $filter) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const onUpdateRateOverride = /* GraphQL */ `
  subscription OnUpdateRateOverride(
    $filter: ModelSubscriptionRateOverrideFilterInput
  ) {
    onUpdateRateOverride(filter: $filter) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const onDeleteRateOverride = /* GraphQL */ `
  subscription OnDeleteRateOverride(
    $filter: ModelSubscriptionRateOverrideFilterInput
  ) {
    onDeleteRateOverride(filter: $filter) {
      crewMemberId
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      rate
      __typename
    }
  }
`;
export const onCreateScope = /* GraphQL */ `
  subscription OnCreateScope($filter: ModelSubscriptionScopeFilterInput) {
    onCreateScope(filter: $filter) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const onUpdateScope = /* GraphQL */ `
  subscription OnUpdateScope($filter: ModelSubscriptionScopeFilterInput) {
    onUpdateScope(filter: $filter) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const onDeleteScope = /* GraphQL */ `
  subscription OnDeleteScope($filter: ModelSubscriptionScopeFilterInput) {
    onDeleteScope(filter: $filter) {
      id
      name
      fullName
      account
      active
      locationId
      __typename
    }
  }
`;
export const onCreateSession = /* GraphQL */ `
  subscription OnCreateSession($filter: ModelSubscriptionSessionFilterInput) {
    onCreateSession(filter: $filter) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onUpdateSession = /* GraphQL */ `
  subscription OnUpdateSession($filter: ModelSubscriptionSessionFilterInput) {
    onUpdateSession(filter: $filter) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onDeleteSession = /* GraphQL */ `
  subscription OnDeleteSession($filter: ModelSubscriptionSessionFilterInput) {
    onDeleteSession(filter: $filter) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      expiry
      createdAt
      tasks {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const onCreateTimeEntry = /* GraphQL */ `
  subscription OnCreateTimeEntry(
    $filter: ModelSubscriptionTimeEntryFilterInput
  ) {
    onCreateTimeEntry(filter: $filter) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const onUpdateTimeEntry = /* GraphQL */ `
  subscription OnUpdateTimeEntry(
    $filter: ModelSubscriptionTimeEntryFilterInput
  ) {
    onUpdateTimeEntry(filter: $filter) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const onDeleteTimeEntry = /* GraphQL */ `
  subscription OnDeleteTimeEntry(
    $filter: ModelSubscriptionTimeEntryFilterInput
  ) {
    onDeleteTimeEntry(filter: $filter) {
      id
      date
      scopeId
      scope {
        id
        name
        fullName
        account
        active
        locationId
        __typename
      }
      hours
      adjustedHours {
        straightTime
        overtime
        __typename
      }
      isApproved
      timeSheetId
      timeSheet {
        id
        locationId
        customerId
        foremanId
        userId
        hours
        allApproved
        date
        isApproved
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      status
      syncStatusMessage
      __typename
    }
  }
`;
export const onCreateTimeSheet = /* GraphQL */ `
  subscription OnCreateTimeSheet(
    $filter: ModelSubscriptionTimeSheetFilterInput
  ) {
    onCreateTimeSheet(filter: $filter) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const onUpdateTimeSheet = /* GraphQL */ `
  subscription OnUpdateTimeSheet(
    $filter: ModelSubscriptionTimeSheetFilterInput
  ) {
    onUpdateTimeSheet(filter: $filter) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const onDeleteTimeSheet = /* GraphQL */ `
  subscription OnDeleteTimeSheet(
    $filter: ModelSubscriptionTimeSheetFilterInput
  ) {
    onDeleteTimeSheet(filter: $filter) {
      id
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      timeEntries {
        nextToken
        __typename
      }
      customerId
      customer {
        id
        number
        name
        active
        locationId
        __typename
      }
      customers {
        id
        number
        name
        active
        locationId
        __typename
      }
      foremanId
      foreman {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      userId
      createdBy {
        id
        email
        firstName
        lastName
        phoneNumber
        expoPushToken
        isNotificationEnabled
        role
        locationId
        crewMemberId
        hasDivisionAccess
        createdAt
        updatedAt
        __typename
      }
      hours
      allApproved
      date
      isApproved
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
    onCreateUser(filter: $filter) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
    onUpdateUser(filter: $filter) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
    onDeleteUser(filter: $filter) {
      id
      email
      firstName
      lastName
      phoneNumber
      expoPushToken
      isNotificationEnabled
      role
      locationId
      location {
        id
        name
        phoneNumber
        address
        address1
        city
        province
        postalCode
        maxDailyHours
        maxWeeklyHours
        utcOffset
        payPeriodStart
        syncTasks
        mediaTargetFilesize
        mediaCompression
        termsOfUseURL
        privacyURL
        supportURL
        __typename
      }
      crewMemberId
      crewMember {
        id
        active
        locationId
        email
        name
        rate
        crewMemberUserId
        __typename
      }
      hasDivisionAccess
      groups {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      divisions {
        id
        name
        division
        locationId
        createdAt
        crewMemberIds
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
